module.exports = __webpack_public_path__ + "static/media/08_tn.3b2ab820.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/08_tn.jpg
// module id = 438
// module chunks = 0